module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment-01-263d055dbec3793b80256e9c2ce54dcf.svg";